import { StyleProp } from "./StyleProp.mjs";
const DefaultSizeStyle = StyleProp.defineEnum("tldraw:size", {
  defaultValue: "m",
  values: ["s", "m", "l", "xl"]
});
export {
  DefaultSizeStyle
};
//# sourceMappingURL=TLSizeStyle.mjs.map
